export const DEFAULT_IDLE_TIMEOUT_MS = 15 * 60 * 1000;
export const DEFAULT_WARNING_BEFORE_MS = 2 * 60 * 1000;

function readPositiveMs(value) {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function resolveIdleSessionConfig() {
  const idleTimeoutMs = readPositiveMs(process.env.REACT_APP_IDLE_TIMEOUT_MS) ?? DEFAULT_IDLE_TIMEOUT_MS;
  let warningBeforeMs = readPositiveMs(process.env.REACT_APP_IDLE_WARNING_MS) ?? DEFAULT_WARNING_BEFORE_MS;
  // ponytail: keep at least 1s active window before warning
  warningBeforeMs = Math.min(warningBeforeMs, Math.max(idleTimeoutMs - 1000, 1000));
  return { idleTimeoutMs, warningBeforeMs };
}

export function formatIdleCountdown(totalSeconds) {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}

export function formatIdleTabTitle(secondsRemaining, baseTitle) {
  return `(${formatIdleCountdown(secondsRemaining)}) ${baseTitle}`;
}

export function stripIdleTabTitlePrefix(title) {
  return title.replace(/^\(\d+:\d{2}\)\s*/, '');
}

export function computeIdlePhase({
  lastActivityAt,
  now,
  idleTimeoutMs = DEFAULT_IDLE_TIMEOUT_MS,
  warningBeforeMs = DEFAULT_WARNING_BEFORE_MS,
}) {
  const idleMs = now - lastActivityAt;
  const warningStartsAt = idleTimeoutMs - warningBeforeMs;

  if (idleMs < warningStartsAt) {
    return { phase: 'active' };
  }

  if (idleMs < idleTimeoutMs) {
    return {
      phase: 'warning',
      secondsRemaining: Math.ceil((idleTimeoutMs - idleMs) / 1000),
    };
  }

  return { phase: 'expired' };
}
